import { forwardRef } from 'react'
import classNames from 'classnames'
import type { ComponentPropsWithRef } from 'react'
import type { CommonProps } from '../@types/common'

export interface TBodyProps extends ComponentPropsWithRef<'tbody'>, CommonProps {}

const TBody = forwardRef<HTMLTableSectionElement, TBodyProps>((props, ref) => {
    const { children, className, ...rest } = props

    const tbodyClass = classNames(className)

    return (
        <tbody ref={ref} className={tbodyClass} {...rest}>
            {children}
        </tbody>
    )
})

TBody.displayName = 'TBody'

export default TBody 